import Button from 'core/display/buttons/Button'
import Image from 'core/display/Image'
import { signal } from 'services/SignalsService'

export default class DecreaseBetButton {
  constructor(data) {
    this.self = new Button(data, new Image(data))

    this.createSignal()

    return this.self
  }

  createSignal() {
    const self = this

    signal.on('MODEL:BET', function () {
      if(self.self.images.length > 1){
        self.self.images[0].visible = game.models.BetModel.getID() == 0
        self.self.images[1].visible = game.models.BetModel.getID() != 0
      }
    })
  }
}
